import { getPlayerAvatar } from '../../utils/player';
import { getBoardCell, getBoardColumns } from '../../utils/eventsView';

// Event standings table (Figma 788:17017 / 791:18371): PLAYER, then the criterion and
// W / L / %. Rows come ranked from getEventStandings (#48); an ended event's
// champion row is picked out in gold.
function BoardTable({ rows, columns, allPlayers, champions = [] }) {
  return (
    <table className="event-table">
      <thead>
        <tr>
          <th scope="col">PLAYER</th>
          {columns.map((c) => (
            <th key={c.id} scope="col" className="event-table__num">
              <abbr title={c.title}>{c.label}</abbr>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr
            key={row.player}
            className={champions.includes(row.player) ? 'is-champion' : undefined}
            style={{ '--pi': Math.min(i, 12) }}
          >
            <td>
              <div className="event-table__player">
                <img src={getPlayerAvatar(allPlayers, row.player)} alt="" className="event-table__avatar" />
                <span className="event-table__name">{row.player}</span>
              </div>
            </td>
            {columns.map((c) => (
              <td key={c.id} className="event-table__num">{getBoardCell(row, c.id)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default function EventLeaderboard({ event, standings, allPlayers, champions = [] }) {
  const qualified = standings.filter((row) => row.qualified);
  const unqualified = standings.filter((row) => !row.qualified);
  const columns = getBoardColumns(event);
  const needs = `${event.minMatches} ${event.minMatches === 1 ? 'match' : 'matches'}`;

  return (
    <div className="event-board">
      {qualified.length > 0 && (
        <BoardTable rows={qualified} columns={columns} allPlayers={allPlayers} champions={champions} />
      )}

      {unqualified.length > 0 && (
        <div className="event-board__unqualified">
          <p className="event-board__label">Not yet qualified · needs {needs}</p>
          <BoardTable rows={unqualified} columns={columns} allPlayers={allPlayers} />
        </div>
      )}
    </div>
  );
}
